import { selectUploadFile } from '@wellesley/uploads'

import { THeader } from '../types'

const getAvatar = (feed: THeader['feed'], showPostOwnerImage?: boolean) => {
  const mainAvatar =
    selectUploadFile({
      size: 40,
      upload: feed.author.avatar,
    })?.uri || ''

  const isSecondaryAvatar = showPostOwnerImage || !!feed.publisher

  const secondaryAvatar =
    selectUploadFile({
      size: 20,
      upload: feed.publisher
        ? feed.publisher.groupAvatar
        : (feed.originalPost?.author || feed.author).avatar,
    })?.uri || ''

  const mainImageName = isSecondaryAvatar
    ? feed.originalPost?.author?.displayName || feed.author.displayName
    : feed.author.displayName

  const secondaryImageName =
    feed.publisher?.displayName || feed.originalPost?.author?.displayName || ''

  return {
    mainAvatar,
    isSecondaryAvatar,
    secondaryAvatar,
    mainImageName,
    secondaryImageName,
  }
}

export default getAvatar
